var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.bannerVisible
    ? _c(
        "div",
        {
          staticClass: "quote-banner mb-2",
          class: _vm.bannerClass,
          attrs: { id: "quote-banner" },
        },
        [
          _c("div", { staticClass: "quote-banner-icon" }, [
            _c("span", { staticClass: "material-symbols-rounded mr-8" }, [
              _vm._v(_vm._s(_vm.iconClass)),
            ]),
          ]),
          _c("div", { staticClass: "quote-banner-content" }, [
            _c("span", { staticClass: "has-text-weight-bold is-size-8" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c("span", { staticClass: "is-size-7" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }